import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
 
function entrypoint() {
    const entrypointblock = document.querySelector('[data-name="entrypoint_nav"]');
    if (!entrypointblock) { return; }
    
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);
    
    // Get all step sections
    const steps = document.querySelectorAll('[id^="step-"]');
    const stepTitles = document.querySelectorAll('[id^="steptitle-"]');
    
    // Calculate a proper offset based on the sticky nav height and some padding
    const stickyNavHeight = entrypointblock.offsetHeight;
    // Use a smaller offset that accounts for the sticky nav position
    const scrollOffset = 60; // This value may need adjustment based on your layout
    
    // Add click events to all step titles
    stepTitles.forEach(stepTitle => {
        stepTitle.style.cursor = 'pointer'; // Change cursor to indicate clickable
        
        stepTitle.addEventListener('click', (e) => {
            e.preventDefault();
            const stepNumber = stepTitle.id.split('-')[1];
            const targetStep = document.getElementById(`step-${stepNumber}`);
            
            if (targetStep) {
                // Get the target position accounting for sticky elements
                const targetPosition = window.pageYOffset + targetStep.getBoundingClientRect().top - scrollOffset;
                
                // Scroll to the step with proper offset
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                
                // Update active state immediately
                stepTitles.forEach(title => {
                    title.classList.add('opacity-50');
                    const span = title.querySelector('span');
                    if (span) span.classList.remove('text-blue-light');
                });
                
                stepTitle.classList.remove('opacity-50');
                const numberSpan = stepTitle.querySelector('span');
                if (numberSpan) numberSpan.classList.add('text-blue-light');
            }
        });
    });
    
    // Make sure the Key Dates button also scrolls smoothly
    const keyDatesButton = document.querySelector('a[href="#keydates"]');
    if (keyDatesButton) {
        keyDatesButton.addEventListener('click', (e) => {
            e.preventDefault();
            const keyDatesSection = document.getElementById('keydates');
            
            if (keyDatesSection) {
                // Get the target position accounting for sticky elements
                const targetPosition = window.pageYOffset + keyDatesSection.getBoundingClientRect().top - scrollOffset;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                
                // Remove active status from all step titles
                stepTitles.forEach(title => {
                    title.classList.add('opacity-50');
                    const span = title.querySelector('span');
                    if (span) span.classList.remove('text-blue-light');
                });
            }
        });
    }
    
    // For each step, create a ScrollTrigger to highlight the corresponding menu item
    steps.forEach(step => {
        const stepNumber = step.id.split('-')[1];
        const stepTitle = document.getElementById(`steptitle-${stepNumber}`);
        
        if (!stepTitle) return;
        
        // Find the span containing the number
        const numberSpan = stepTitle.querySelector('span');
        
        ScrollTrigger.create({
            trigger: step,
            start: 'top 100px', // When the top of the step reaches 100px from the top of viewport
            end: 'bottom 100px',
            onEnter: () => {
                // Reset all step titles
                document.querySelectorAll('[id^="steptitle-"]').forEach(title => {
                    title.classList.add('opacity-50');
                    const span = title.querySelector('span');
                    if (span) span.classList.remove('text-blue-light');
                });
                
                // Highlight the current step title
                stepTitle.classList.remove('opacity-50');
                if (numberSpan) numberSpan.classList.add('text-blue-light');
            },
            onEnterBack: () => {
                // Same behavior when scrolling back up
                document.querySelectorAll('[id^="steptitle-"]').forEach(title => {
                    title.classList.add('opacity-50');
                    const span = title.querySelector('span');
                    if (span) span.classList.remove('text-blue-light');
                });
                
                stepTitle.classList.remove('opacity-50');
                if (numberSpan) numberSpan.classList.add('text-blue-light');
            }
        });
    });
}

export { entrypoint }; 